/* eslint-disable */
export enum uploadLocalisationKeys {
  UPLOAD = 'UPLOAD',
  UPLOAD_MEETING_ROOM = 'UPLOAD_MEETING_ROOM',
  TO_SEE_IT_COMPARE = 'TO_SEE_IT_COMPARE',
  MUST_BE_CSV = 'MUST_BE_CSV',
  MAX_SIZE_ERROR = 'MAX_SIZE_ERROR',
  WRONG_FORMAT_ERROR= 'WRONG_FORMAT_ERROR',
  UPLOAD_SHEETS = 'UPLOAD_SHEETS',
  ADVANCED_PARSING_OPTIONS = 'ADVANCED_PARSING_OPTIONS',
  ADVANCED_PARSING_OPTIONS_HEADER = 'ADVANCED_PARSING_OPTIONS_HEADER',
  SAVE = 'SAVE'
}

export const enUploadLocalisationMessages = {
  [uploadLocalisationKeys.UPLOAD]: `Upload`,
  [uploadLocalisationKeys.UPLOAD_MEETING_ROOM]: `Upload your meeting room reservation`,
  [uploadLocalisationKeys.TO_SEE_IT_COMPARE]: `to see it compared to actual occupancy.`,
  [uploadLocalisationKeys.MUST_BE_CSV]: `Files must be in csv or xlsx format. Click here for more information.`,
  [uploadLocalisationKeys.MAX_SIZE_ERROR]: `Maximum file size of 100MB exceeded.`,
  [uploadLocalisationKeys.WRONG_FORMAT_ERROR]: `Incorrect file format. Please upload a csv file.`,
  [uploadLocalisationKeys.UPLOAD_SHEETS]: `The uploaded spreadsheet has multiple worksheets (tabs). Please select the name of the worksheet to process from the list.`,
  [uploadLocalisationKeys.ADVANCED_PARSING_OPTIONS]: `Advanced parsing options`,
  [uploadLocalisationKeys.ADVANCED_PARSING_OPTIONS_HEADER]: `Select advanced parsing options for uploaded file`,
  [uploadLocalisationKeys.SAVE]: `Save`
}
